import React from "react";
import { Chip, ShapeEnum } from "../Chip/Chip";
import { FontWeightEnum } from "../../../types/AppTypes";
import { BodyTyp } from "../../Typography/Typography";
import { StyledContentNumberChip } from "./NumberChip.styled";

type NumberChipProps = {
  id: number | string;
  number: number;
  color?: string;
  isSelect?: boolean;
  setSelected?: (x: number | string) => void;
};

export const NumberChip = ({
  id,
  number,
  color,
  isSelect = false,
  setSelected,
}: NumberChipProps) => {
  const content = {
    value: id,
    label: (
      <StyledContentNumberChip>
        <BodyTyp fontWeight={FontWeightEnum.SEMIBOLD} variant="3" noLineHeight>
          {number}
        </BodyTyp>
      </StyledContentNumberChip>
    ),
  };

  return (
    <Chip
      option={content}
      borderColor={color}
      selectedChip={isSelect}
      onSelectChip={setSelected}
      shape={ShapeEnum.ROUND}
      readonly
      borderWidth={2}
    />
  );
};
